import { Component, HostBinding, inject, type OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SignalRService } from './core/services/signal-r.service';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { GlobalApiErrorHandlerService } from './core/services/global-api-error-handler.service';
import { ThemeService } from './core/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
  ],
  templateUrl: './app.html',
  styleUrls: ['./app.scss']
})
export class App implements OnInit {
  @HostBinding('class') hostClass = 'flex grow';

  private readonly _signalR = inject(SignalRService);
  private readonly _title = inject(Title);
  private readonly _globalErrorHandler = inject(GlobalApiErrorHandlerService);
  private readonly _themeService = inject(ThemeService);

  title = 'Herop';

  ngOnInit(): void {
    // Inizializza il global error handler
    this._globalErrorHandler.initialize();
    
    this._signalR.startConnection();

    let title = `${environment.APP_NAME}`;
    if (environment.ENV != null && environment.production === false) {
      title += ` - ${environment.ENV}`;
    }
    this._title.setTitle(title);
  }
}
